import { configureStore, ThunkAction, Action, combineReducers } from '@reduxjs/toolkit';
import alertSlice from './alertSlice';
import answers from './answerSlice';
import assessments from './assessmentSlice';
import bestPractices from './bestPracticeSlice';
import certification from './certificationSlice';
import certificationControl from './certificationControlSlice';
import companyList from './companyList';
import domains from './domainSlice';
import fileSlice from './fileSlice';
import inclusionConfigurations from './inclusionConfigurationSlice';
import masquerade from './masqueradeSlice';
import questionnaires from './questionnaireSlice';
import questionnaireAnswer from './questionnaireAnswerSlice';
import questions from './questionSlice';
import remediationFilterSlice from './remediationFilterSlice';
import serviceCategories from './serviceCategories';
import surveys from './surveySlice';
import topics from './topicSlice';
import user from './userSlice';
import users from './usersSlice';
import workflow from './workflowSlice';
import secondaryLayoutButtonSlice from './secondaryLayoutButtonSlice';
import workflowProcessingSlice from './workflowProcessingSlice';
import uiSlice from './uiSlice';

import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  whitelist: ['user', 'masquerade'],
};

const rootReducer = combineReducers({
  alertSlice,
  answers,
  assessments,
  bestPractices,
  certification,
  certificationControl,
  companyList,
  domains,
  fileSlice,
  inclusionConfigurations,
  masquerade,
  questionnaires,
  questionnaireAnswer,
  questions,
  remediationFilterSlice,
  workflowProcessingSlice,
  secondaryLayoutButtonSlice,
  serviceCategories,
  surveys,
  topics,
  uiSlice,
  user,
  users,
  workflow,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: {
        ignoredPaths: ['survey', 'questionnaireAnswer'],
      },
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        ignoredPaths: ['survey', 'questionnaireAnswer'],
      },
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
ReturnType,
RootState,
unknown,
Action<string>
>;
